const issues = {
  getOverviewIssueList(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/issues/list', Object.assign(defaults, { data }));
  },
  getOverviewIssueDetail(data, uploadedFileid) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/reports/${uploadedFileid}/issue_overview`, Object.assign(defaults, { data }));
  },
  searchIssueOwner(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/issues/search-owner', Object.assign(defaults, { data }));
  },
  setAssignIssue(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/issues/assign-owner', Object.assign(defaults, { data }));
  },
  setAssignMyIssue(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/issues/my/assign-owner', Object.assign(defaults, { data }));
  },
  updateStatusIssue(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/issues/change-status', Object.assign(defaults, { data }));
  },
  updateStatusMyIssue(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/issues/my/change-status', Object.assign(defaults, { data }));
  },
  getMyIssueSummary() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/issues/my/summary', defaults);
  },
  getMyIssueList(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/issues/my/list', Object.assign(defaults, { data }));
  },
  getMyIssueDetail(data, uploadedFileid) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/reports/${uploadedFileid}/my_issue_overview`, Object.assign(defaults, { data }));
  },
  getIssueOwner(uploadedFileid) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/reports/${uploadedFileid}/issue_owner`, defaults);
  },

  getSecurityFileIssues(ids) {
    const uploadedFileid = ids.uploadedFileId;
    const { scannedFileId } = ids;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileid}/files/${scannedFileId}/security_issues`, defaults);
  },

  setSecurityFileIssues(data, ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/security_issues`, Object.assign(defaults, { data }));
  },

  getLicenseFileIssues(ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/license_issues`, defaults);
  },

  setLicenseFileIssues(data, ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/license_issues`, Object.assign(defaults, { data }));
  },

  getLitigatorFileIssues(ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/litigator_issues`, defaults);
  },

  setLitigatorFileIssues(data, ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/litigator_issues`, Object.assign(defaults, { data }));
  },

  getSecurityComponentIssues(ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const { componentId } = ids;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/components/${componentId}/security_issues`, defaults);
  },

  setSecurityComponentIssues(data, ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const { componentId } = ids;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/components/${componentId}/security_issues`, Object.assign(defaults, { data }));
  },

  getLicenseComponentIssues(ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const { componentId } = ids;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/components/${componentId}/license_issues`, defaults);
  },

  setLicenseComponentIssues(data, ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const { componentId } = ids;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/components/${componentId}/license_issues`, Object.assign(defaults, { data }));
  },

  getLitigatorComponentIssues(ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const { componentId } = ids;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/components/${componentId}/litigator_issues`, defaults);
  },

  setLitigatorComponentIssues(data, ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const { componentId } = ids;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/components/${componentId}/litigator_issues`, Object.assign(defaults, { data }));
  },

  searchDetailIssueOwner(data, ufid) {
    const uploadedFileId = ufid;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/reports/${uploadedFileId}/search_owner`, Object.assign(defaults, { data }));
  },

  getMySecurityFileIssues(ids) {
    const uploadedFileid = ids.uploadedFileId;
    const { scannedFileId } = ids;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileid}/files/${scannedFileId}/security_my_issues`, defaults);
  },

  setMySecurityFileIssues(data, ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/security_my_issues`, Object.assign(defaults, { data }));
  },

  getMyLicenseFileIssues(ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/license_my_issues`, defaults);
  },

  setMyLicenseFileIssues(data, ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/license_my_issues`, Object.assign(defaults, { data }));
  },

  getMyLitigatorFileIssues(ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/litigator_my_issues`, defaults);
  },

  setMyLitigatorFileIssues(data, ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/litigator_my_issues`, Object.assign(defaults, { data }));
  },

  getMySecurityComponentIssues(ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const { componentId } = ids;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/components/${componentId}/security_my_issues`, defaults);
  },

  setMySecurityComponentIssues(data, ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const { componentId } = ids;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/components/${componentId}/security_my_issues`, Object.assign(defaults, { data }));
  },

  getMyLicenseComponentIssues(ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const { componentId } = ids;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/components/${componentId}/license_my_issues`, defaults);
  },

  setMyLicenseComponentIssues(data, ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const { componentId } = ids;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/components/${componentId}/license_my_issues`, Object.assign(defaults, { data }));
  },

  getMyLitigatorComponentIssues(ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const { componentId } = ids;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/components/${componentId}/litigator_my_issues`, defaults);
  },

  setMyLitigatorComponentIssues(data, ids) {
    const { uploadedFileId } = ids;
    const { scannedFileId } = ids;
    const { componentId } = ids;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/components/${componentId}/litigator_my_issues`, Object.assign(defaults, { data }));
  },
};

export default issues;
